<template>
    <footer class="copyright-footer">
      © {{ currentYear }} SkillSynchrony. All rights reserved.
    </footer>
  </template>
  
  <script>
  export default {
    name: 'CopyrightFooter',
    data() {
      return {
        currentYear: new Date().getFullYear(),
      };
    },
  };
  </script>
  
  <style scoped>
  /* Add your footer styling here */
  footer {
    text-align: center;
    padding: 20px;
    margin-top: 20px;
    color: #fff;
  }
  </style>